var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticStyle:{"height":"330px"}},[_c('div',{ref:"column",staticClass:"column",staticStyle:{"width":"100%"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }